import React from 'react';
import {
  Card, CardActionArea, CardHeader, Container, IconButton, Stack,
} from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';
import { Link } from 'react-router-dom';

const LINKS = [
  {
    title: 'Availability & Capacity',
    content: "See partner's availability and capacity",
    icon: <OutlinedIcons.OutlinedCalendarIcon color="primary" />,
    to: './availability',
  },
  {
    title: 'Countries',
    content: "Manage partner's countries",
    icon: <OutlinedIcons.OutlinedGlobeAltIcon color="primary" />,
    to: './countries',
  },
  {
    title: 'Non-Compete',
    content: 'Specify other partners to avoid in matching',
    icon: <OutlinedIcons.OutlinedSwitchHorizontalIcon color="primary" />,
    to: './non-compete',
  },
  {
    title: 'Matching Notes',
    content: 'Manage partner\'s priority & notes',
    icon: <OutlinedIcons.OutlinedPencilAltIcon color="primary" />,
    to: './notes',
  },
];

const SettingsHomeView = () => (
  <Container maxWidth="md" sx={{ my: 6 }}>
    <Stack spacing={1.5}>
      {LINKS.map((link) => (
        <Card
          key={link.title}
          component={Link}
          to={link.to}
          sx={{
            textDecoration: 'none',
          }}
        >
          <CardHeader
            component={CardActionArea}
            title={link.title}
            titleTypographyProps={{
              variant: 'bodyBold',
            }}
            subheader={link.content}
            action={(
              <IconButton
                component="div"
                disabled
                size="large"
              >
                {link.icon}
              </IconButton>
            )}
          />
        </Card>
      ))}
    </Stack>
  </Container>
);

export default SettingsHomeView;
